<nav class="navbar m-header" style="z-index: 999;">
  <!-- Logo -->
  <div class="logo">
    <a href="{{redirectUrl}}">
      <img class="logo-img" src="assets/cablepro/logo/elek-logo.svg" alt="Logo" height="40" width="123">
    </a>

    <div style="display: flex;gap: 5px;align-items: center;">
      <button *ngIf="user && user.id > 0 && !user.isWebFacingUser" class="btn btn-blue mobile-display"
        (click)="onAllProjectsClick()">
        Saved Calculations
      </button>
      <button *ngIf="showReportButton && !(_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1  || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)" (click)="onReportClick()" class="btn multiActionIcon btn-blue mobile-display"
        style="width: auto;">
        Report
      </button>
      <div class="btn-group ml-0 theme-custom mobile-display"
        *ngIf="showReportButton && (_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1 || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)">
        <a href="javascript:;" class="dropdown-toggle btn multiActionIcon theme-custom-btn" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <i class="flaticon-file"></i> Report
        </a>
        <div class="dropdown-menu" style="width: 99% !important;">
          <a class="dropdown-item" href="javascript:void(0);" (click)="onReportClick()">Cable Sizing</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="onCalculationStep()">Calculation Steps <img
              [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FDCSCSIS) ? 'crown-grey' : 'crown-yellow'"
              class="" src="assets/cablepro/img/crown-solid.svg" height="12.27" width="12.27" alt="Premium"
              style="vertical-align: baseline;"></a>
        </div>
      </div>
      <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;" (click)="toggleMobileMenu()"
        class="m-brand__icon m--visible-tablet-and-mobile-inline-block mobile-display">
        <i class="flaticon-more"></i>
      </a>
    </div>
  </div>

  <div class="action-container web-display">
    <div class="report-dropdown-container">
      <button *ngIf="user && user.id > 0 && !user.isWebFacingUser" class="btn btn-blue" (click)="onAllProjectsClick()">
        Saved Calculations
      </button>
      <button (click)="onReportClick()"
        *ngIf="showReportButton && !(_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1  || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)"
        class="btn multiActionIcon btn-blue ml-0"  [class.disabled]="isReportDisabled">
        Generate Report
      </button>
      <div class="btn-group ml-0 theme-custom"
        *ngIf="showReportButton && (_router.url.indexOf('/cable-sizing-as') > -1 || _router.url.indexOf('/cable-sizing-bs') > -1 || _router.url.indexOf('/cable-sizing-nz') > -1 || _router.url.indexOf('/cable-sizing-nec') > -1)">
        <a href="javascript:;" class="dropdown-toggle btn multiActionIcon theme-custom-btn" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" [class.disabled]="isReportDisabled">
          <i class="flaticon-file"></i> Generate Report
        </a>
        <div class="dropdown-menu" style="width: 99% !important;">
          <a class="dropdown-item" href="javascript:void(0);" (click)="onReportClick()">Cable Sizing</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="onCalculationStep()">Calculation Steps <img
              [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FDCSCSIS) ? 'crown-grey' : 'crown-yellow'"
              class="" src="assets/cablepro/img/crown-solid.svg" height="12.27" width="12.27" alt="Premium"
              style="vertical-align: baseline;"></a>
        </div>
      </div>
      <div class="dropdown" *ngIf="showReportButton">
        <a class="btn btn-secondary help-link help-adjust dropdown-toggle select-calculator" type="button"
          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{ selectedCalculatorName || 'Select Calculator' }}
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" *ngFor="let calculator of calculators"
            [ngClass]="{'disabled': calculator.disabled, 'text-bold': calculator.value == selectedCalculator}"
            (click)="onCalculationChange(calculator)">
            {{ calculator.name }}
          </a>
        </div>
      </div>
    </div>
    <div style="display: flex;flex-direction: row;gap: 0.5rem;">
      <div style="display: flex; flex-direction: column;align-items: center;justify-content: center;margin-left: auto;"
        *ngIf="user && user.id > 0 && !user.isWebFacingUser">
        <span class="text-truncate">
          {{ user.emailAddress }}
        </span>
        <span class="badge" [ngClass]="{
          'badge-info': user.userStripePlanLevel == 1,
          'badge-primary': user.userStripePlanLevel == 2,
          'badge-success': user.userStripePlanLevel == 3
        }">
          {{ getLatestPlanName(user.userStripePlanLevel) }}
        </span>
      </div>
      <button *ngIf="!isAdminUser && (!isAnnualProfessionalPlan) && !(_router.url.indexOf('/pricing') > -1)"
        class="btn btn-blue" (click)="UpgradePlan()">
        Pricing
      </button>
      <button *ngIf="!user || user.isWebFacingUser" class="btn btn-blue ml-0" (click)="onLogin()">
        Log In
      </button>
      <button *ngIf="user && user.id > 0 && !user.isWebFacingUser" class="btn btn-blue ml-0" (click)="logout()">
        Log Out
      </button>

    </div>
  </div>

</nav>
<div id="m_header_topbar" class="webfacing-toggle-header mobile-display m-topbar m-stack m-stack--ver m-stack--general"
  style="justify-content: flex-end;z-index: 970;display: flex;align-items: center;padding: .5rem 15px !important;gap: 0.5rem;position: fixed;top: 0;">
  <div class="dropdown" *ngIf="showReportButton">
    <a class="btn btn-secondary help-link help-adjust dropdown-toggle select-calculator" type="button" id="dropdownMenuButton"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{ selectedCalculatorName || 'Select Calculator' }}
    </a>

    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" *ngFor="let calculator of calculators"
        [ngClass]="{'disabled': calculator.disabled, 'text-bold': calculator.value == selectedCalculator}"
        (click)="onCalculationChange(calculator)">
        {{ calculator.name }}
      </a>
    </div>
  </div>
  <button *ngIf="!isAdminUser && (!isAnnualProfessionalPlan) && !(_router.url.indexOf('/pricing') > -1)"
    class="btn btn-blue" (click)="UpgradePlan()">
    Pricing
  </button>
  <button *ngIf="user && user.id > 0 && !user.isWebFacingUser" class="btn btn-blue ml-0" (click)="logout()">
    Log Out
  </button>
  <button *ngIf="!user || user.isWebFacingUser" class="btn btn-blue ml-0" (click)="onLogin()">
    Log In
  </button>
</div>

<div class="powered-by-sticky" *ngIf="showReportButton">
  <span class="powered-by-text">Powered by</span>
  <a (click)="redirectToFullAppUrl()" class="powered-by-btn">Cable Pro Web<sup>TM</sup></a>
</div>